(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4076],{

/***/ 17084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ molecules_TextField; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./src/components/atoms/TextInput/index.tsx
var TextInput = __webpack_require__(74398);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/components/molecules/TextField/TextField.styled.tsx

var TextFieldContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TextFieldstyled__TextFieldContainer",
  componentId: "sc-365i6q-0"
})(["display:flex;flex-direction:column;"]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/molecules/TextField/TextField.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var TextField = function TextField(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextFieldContainer, {
    style: props.styles,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
      name: props.name,
      children: function children(field) {
        var _props$type;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, _objectSpread(_objectSpread({
          name: props.name,
          size: props.size,
          placeholder: props.placeholder,
          paddingLeft: 15,
          paddingRight: 15
        }, field), {}, {
          type: (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'text',
          errorMessage: props.errorMessage,
          disabled: props.disabled
        }));
      }
    })
  });
};

/* harmony default export */ var TextField_TextField = (TextField);
;// CONCATENATED MODULE: ./src/components/molecules/TextField/index.tsx

/* harmony default export */ var molecules_TextField = (TextField_TextField);

/***/ }),

/***/ 46501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CreateAPIRoute; }
/* harmony export */ });
/* harmony import */ var _Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50029);
/* harmony import */ var _Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var msw__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59436);
/* harmony import */ var msw__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(msw__WEBPACK_IMPORTED_MODULE_2__);
/* provided dependency */ var process = __webpack_require__(34155);



function CreateAPIRoute(config) {
  var client = config.client,
      path = config.path,
      method = config.method,
      mockData = config.mockData,
      errorMessages = config.errorMessages;
  var APIRoute;

  if (method === 'get') {
    APIRoute = /*#__PURE__*/function () {
      var _ref = (0,_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var url, data;
        return _Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = new URL(path, "https://api.dealerportal.eyeforce.com");

                if (config.beforeRequest) {
                  params = config.beforeRequest(params);
                }

                if (params) {
                  Object.keys(params).forEach(function (key) {
                    if (params) {
                      url.searchParams.set(key, params[key]);
                    }
                  });
                }

                _context.next = 5;
                return client.get(url.href, config.headers);

              case 5:
                data = _context.sent;

                if (data.data) {
                  _context.next = 8;
                  break;
                }

                throw new Error('API Error');

              case 8:
                return _context.abrupt("return", data.data);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function APIRoute(_x) {
        return _ref.apply(this, arguments);
      };
    }();
  } else if (method === 'post') {
    APIRoute = /*#__PURE__*/function () {
      var _ref2 = (0,_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(params) {
        var requestParams, data, errorMessage;
        return _Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                requestParams = params;

                if (config.beforeRequest) {
                  requestParams = config.beforeRequest(params);
                }

                _context2.prev = 2;
                _context2.next = 5;
                return client.post(path, requestParams, config.headers ? {
                  headers: config.headers
                } : undefined);

              case 5:
                data = _context2.sent;

                if (data.data) {
                  _context2.next = 8;
                  break;
                }

                throw new Error('API Error');

              case 8:
                return _context2.abrupt("return", data.data);

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](2);

                if (!(_context2.t0 instanceof Error)) {
                  _context2.next = 18;
                  break;
                }

                if (!config.errorMessages) {
                  _context2.next = 18;
                  break;
                }

                console.log(_context2.t0.cause);
                errorMessage = config.errorMessages[_context2.t0.cause];
                throw new Error(_context2.t0.message, {
                  cause: errorMessage
                });

              case 18:
                throw new Error(_context2.t0);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 11]]);
      }));

      return function APIRoute(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
  } else if (method === 'patch') {
    APIRoute = /*#__PURE__*/function () {
      var _ref3 = (0,_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(params) {
        var data;
        return _Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (config.beforeRequest) {
                  params = config.beforeRequest(params);
                }

                _context3.next = 3;
                return client.patch(path, params, config.headers);

              case 3:
                data = _context3.sent;

                if (data.data) {
                  _context3.next = 6;
                  break;
                }

                throw new Error('API Error');

              case 6:
                return _context3.abrupt("return", data.data);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function APIRoute(_x3) {
        return _ref3.apply(this, arguments);
      };
    }();
  } else if (method === 'delete') {
    APIRoute = /*#__PURE__*/function () {
      var _ref4 = (0,_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(params) {
        var data;
        return _Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (config.beforeRequest) {
                  params = config.beforeRequest(params);
                }

                _context4.next = 3;
                return client["delete"](path, {
                  data: params
                });

              case 3:
                data = _context4.sent;

                if (data.data) {
                  _context4.next = 6;
                  break;
                }

                throw new Error('API Error');

              case 6:
                return _context4.abrupt("return", data.data);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function APIRoute(_x4) {
        return _ref4.apply(this, arguments);
      };
    }();
  }

  if (APIRoute === undefined) {
    throw new Error('Invalid method');
  }

  var MSW = {
    NORMAL: msw__WEBPACK_IMPORTED_MODULE_2__.rest[method]("".concat(process.env.API_URL).concat(path), /*#__PURE__*/function () {
      var _ref5 = (0,_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(req, res, ctx) {
        var params;
        return _Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(method === 'get')) {
                  _context5.next = 4;
                  break;
                }

                params = req.params;
                _context5.next = 7;
                break;

              case 4:
                _context5.next = 6;
                return req.json();

              case 6:
                params = _context5.sent;

              case 7:
                return _context5.abrupt("return", res(ctx.json({
                  data: mockData(params)
                })));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x5, _x6, _x7) {
        return _ref5.apply(this, arguments);
      };
    }()),
    SLOW: msw__WEBPACK_IMPORTED_MODULE_2__.rest[method]("".concat(process.env.API_URL).concat(path), /*#__PURE__*/function () {
      var _ref6 = (0,_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(req, res, ctx) {
        var params;
        return _Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(method === 'get')) {
                  _context6.next = 4;
                  break;
                }

                params = req.params;
                _context6.next = 7;
                break;

              case 4:
                _context6.next = 6;
                return req.json();

              case 6:
                params = _context6.sent;

              case 7:
                _context6.next = 9;
                return new Promise(function (resolve) {
                  return setInterval(function () {
                    return resolve(res(ctx.json({
                      data: mockData(params)
                    })));
                  }, 5000);
                });

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x8, _x9, _x10) {
        return _ref6.apply(this, arguments);
      };
    }()),
    ERROR: msw__WEBPACK_IMPORTED_MODULE_2__.rest[method]("".concat(process.env.API_URL).concat(path), function (req, res, ctx) {
      return res(ctx.json({
        error: 'Server Error'
      }));
    })
  };
  return {
    APIRoute: APIRoute,
    MSW: MSW
  };
}

/***/ }),

/***/ 43892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ forgot_password_ForgotPassword; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/config/sitemap.ts
var sitemap = __webpack_require__(65723);
// EXTERNAL MODULE: ./src/lib/api/CreateRoute.ts
var CreateRoute = __webpack_require__(46501);
// EXTERNAL MODULE: ./src/lib/api/portal-api/client.ts + 1 modules
var client = __webpack_require__(98766);
;// CONCATENATED MODULE: ./src/lib/api/portal-api-v2/auth/password-reset/start.ts



var _CreateAPIRoute = (0,CreateRoute/* default */.Z)({
  client: client/* default */.Z,
  path: 'auth/password-reset/start',
  method: 'post',
  mockData: function mockData(params) {
    return true;
  },
  //   beforeRequest: (params) => {
  //     return params;
  //   },
  errorMessages: {
    'User does not exist': 'This email does not exist. Please register an account.'
  }
}),
    APIRoute = _CreateAPIRoute.APIRoute,
    MSW = _CreateAPIRoute.MSW;

var AuthPasswordReset = {
  APIRoute: APIRoute,
  MSW: MSW
};
/* harmony default export */ var start = (AuthPasswordReset);
// EXTERNAL MODULE: ./src/components/molecules/ButtonWithIcon/index.tsx + 1 modules
var ButtonWithIcon = __webpack_require__(7288);
// EXTERNAL MODULE: ./src/components/molecules/ProgressTracker/index.tsx + 5 modules
var ProgressTracker = __webpack_require__(67368);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./src/components/atoms/Button/index.tsx + 1 modules
var Button = __webpack_require__(71800);
// EXTERNAL MODULE: ./src/components/atoms/TextInput/styled.tsx
var styled = __webpack_require__(25018);
// EXTERNAL MODULE: ./src/components/molecules/LogoWithTitle/index.tsx + 1 modules
var LogoWithTitle = __webpack_require__(95259);
// EXTERNAL MODULE: ./src/components/molecules/TextField/index.tsx + 2 modules
var TextField = __webpack_require__(17084);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./src/components/atoms/Fonts/index.tsx
var Fonts = __webpack_require__(73648);
;// CONCATENATED MODULE: ./src/components/organisms/ForgotPasswordStepOne/ForgotPasswordStepOne.styled.tsx


var ForgotPasswordStepOneContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ForgotPasswordStepOnestyled__ForgotPasswordStepOneContainer",
  componentId: "sc-pcka7k-0"
})(["display:flex;flex-direction:column;align-items:center;"]);
var Subheader = (0,styled_components_browser_esm/* default */.ZP)(Fonts/* SubTitle */.DK).withConfig({
  displayName: "ForgotPasswordStepOnestyled__Subheader",
  componentId: "sc-pcka7k-1"
})(["color:", ";margin-top:8px;"], function (props) {
  return props.theme.colors.text["default"];
});
var FormWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ForgotPasswordStepOnestyled__FormWrapper",
  componentId: "sc-pcka7k-2"
})(["margin-bottom:24px;width:100%;"]);
var FieldWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ForgotPasswordStepOnestyled__FieldWrapper",
  componentId: "sc-pcka7k-3"
})(["margin:24px 0;"]);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./src/components/organisms/ForgotPasswordStepOne/ForgotPasswordStepOne.types.tsx

var forgotPasswordSchema = es/* object */.Ry({
  email: es/* string */.Z_().required('Email is required')
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/organisms/ForgotPasswordStepOne/ForgotPasswordStepOne.tsx










/*TODO: We should lift the <Formik> component up to the parent. This will make it easier to set network errors and test in storybook using Formik Addon
https://github.com/bbbtech/storybook-formik
*/
var ForgotPasswordStepOne = function ForgotPasswordStepOne(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ForgotPasswordStepOneContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LogoWithTitle/* default */.Z, {
      title: "Forgot Password?",
      gap: 80
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Subheader, {
      children: "We'll send you reset instructions."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
          email: ''
        },
        onSubmit: function onSubmit(values) {
          return props.onSubmit(values);
        },
        validationSchema: forgotPasswordSchema,
        children: function children(_ref) {
          var errors = _ref.errors;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FieldWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
                name: "email",
                size: "lg",
                placeholder: "Email",
                errorMessage: errors.email
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              size: "lg",
              variant: "primary",
              type: "submit",
              block: true,
              children: "CONTINUE"
            }), props.error ? /*#__PURE__*/(0,jsx_runtime.jsx)(styled/* StyledErrorMessage */.Vv, {
              children: props.error
            }) : null]
          });
        }
      })
    })]
  });
};

/* harmony default export */ var ForgotPasswordStepOne_ForgotPasswordStepOne = (ForgotPasswordStepOne);
;// CONCATENATED MODULE: ./src/components/organisms/ForgotPasswordStepOne/index.tsx

/* harmony default export */ var organisms_ForgotPasswordStepOne = (ForgotPasswordStepOne_ForgotPasswordStepOne);
// EXTERNAL MODULE: ./src/styles/breakpoints/index.ts
var breakpoints = __webpack_require__(15143);
;// CONCATENATED MODULE: ./src/components/organisms/ForgotPasswordStepTwo/ForgotPasswordStepTwo.styled.tsx



var ForgotPasswordStepTwoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ForgotPasswordStepTwostyled__ForgotPasswordStepTwoContainer",
  componentId: "sc-1cnfx57-0"
})(["display:flex;flex-direction:column;align-items:center;"]);
var ForgotPasswordStepTwo_styled_Subheader = (0,styled_components_browser_esm/* default */.ZP)(Fonts/* BodyText3 */.CB).withConfig({
  displayName: "ForgotPasswordStepTwostyled__Subheader",
  componentId: "sc-1cnfx57-1"
})(["margin-top:8px;color:", ";"], function (props) {
  return props.theme.colors.text["default"];
});
var EmailLabel = (0,styled_components_browser_esm/* default */.ZP)(Fonts/* BodyText2 */.A0).withConfig({
  displayName: "ForgotPasswordStepTwostyled__EmailLabel",
  componentId: "sc-1cnfx57-2"
})(["color:", ";margin-top:8px;"], function (props) {
  return props.theme.colors.theme.neutralDark.dark;
});
var FooterWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ForgotPasswordStepTwostyled__FooterWrapper",
  componentId: "sc-1cnfx57-3"
})(["margin:80px 0 24px 0;display:flex;align-items:center;@media ", "{flex-direction:column;}"], breakpoints/* device.mobile */.U.mobile);
var DidntReceiveLabel = (0,styled_components_browser_esm/* default */.ZP)(Fonts/* BodyText1 */.NE).withConfig({
  displayName: "ForgotPasswordStepTwostyled__DidntReceiveLabel",
  componentId: "sc-1cnfx57-4"
})(["margin:0;margin-right:8px;color:", ";@media ", "{margin-bottom:8px;}"], function (props) {
  return props.theme.colors.text["default"];
}, breakpoints/* device.mobile */.U.mobile);
var LogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ForgotPasswordStepTwostyled__LogoWrapper",
  componentId: "sc-1cnfx57-5"
})(["@media ", "{}"], breakpoints/* device.mobile */.U.mobile);
;// CONCATENATED MODULE: ./src/components/organisms/ForgotPasswordStepTwo/ForgotPasswordStepTwo.tsx






var ForgotPasswordStepTwo = function ForgotPasswordStepTwo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ForgotPasswordStepTwoContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LogoWithTitle/* default */.Z, {
        title: "Check your Email",
        gap: 80
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ForgotPasswordStepTwo_styled_Subheader, {
      children: "We sent a password reset link to"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(EmailLabel, {
      children: props.email
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FooterWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DidntReceiveLabel, {
        children: "Didn't receive the email?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        size: "lg",
        variant: "link",
        onClick: props.onResendClick,
        disabled: props.resendDisabled,
        children: "CLICK TO RESEND"
      })]
    })]
  });
};

/* harmony default export */ var ForgotPasswordStepTwo_ForgotPasswordStepTwo = (ForgotPasswordStepTwo);
;// CONCATENATED MODULE: ./src/components/organisms/ForgotPasswordStepTwo/index.tsx

/* harmony default export */ var organisms_ForgotPasswordStepTwo = (ForgotPasswordStepTwo_ForgotPasswordStepTwo);
;// CONCATENATED MODULE: ./src/components/pages/ForgotPassword/ForgotPassword.styled.tsx


var Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ForgotPasswordstyled__Body",
  componentId: "sc-1e7mbri-0"
})(["width:100%;"]);
var ForgotPasswordContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ForgotPasswordstyled__ForgotPasswordContainer",
  componentId: "sc-1e7mbri-1"
})(["@media ", "{display:flex;justify-content:center;}"], breakpoints/* device.desktopOnly */.U.desktopOnly);
var TrackerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ForgotPasswordstyled__TrackerWrapper",
  componentId: "sc-1e7mbri-2"
})(["margin-top:168px;margin-bottom:80px;"]);
var Inner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ForgotPasswordstyled__Inner",
  componentId: "sc-1e7mbri-3"
})(["display:flex;flex-direction:column;margin:80px 128px;justify-content:start;align-items:center;@media ", "{max-width:352px;width:100%;}@media ", "{margin:80px 50px;}@media ", "{margin:80px 26px;}"], breakpoints/* device.desktopOnly */.U.desktopOnly, breakpoints/* device.tablet */.U.tablet, breakpoints/* device.mobile */.U.mobile);
;// CONCATENATED MODULE: ./src/components/pages/ForgotPassword/ForgotPassword.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var ForgotPasswordPage = function ForgotPasswordPage(props) {
  var _props$initialStep;

  var _useState = (0,react.useState)({
    values: {
      email: ''
    },
    step: (_props$initialStep = props.initialStep) !== null && _props$initialStep !== void 0 ? _props$initialStep : 0,
    resendDisabled: false
  }),
      state = _useState[0],
      setState = _useState[1];

  var mutation = (0,useMutation/* useMutation */.D)({
    mutationFn: function mutationFn(input) {
      return start.APIRoute({
        email: input.email
      });
    },
    onError: function onError(error) {
      var er = error;
      return er;
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ForgotPasswordContainer, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Inner, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Body, {
        children: [state.step === 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(organisms_ForgotPasswordStepOne, {
          error: mutation.error && mutation.error instanceof Error ? mutation.error.cause : '',
          onSubmit: /*#__PURE__*/function () {
            var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
              var data;
              return regenerator_default().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return mutation.mutateAsync(values);

                    case 2:
                      data = _context.sent;

                      if (data === true) {
                        setState(_objectSpread(_objectSpread({}, state), {}, {
                          step: 1,
                          values: {
                            email: values.email
                          }
                        }));
                      }

                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()
        }) : null, state.step === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(organisms_ForgotPasswordStepTwo, {
          email: state.values.email,
          onResendClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
            var data;
            return regenerator_default().wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return mutation.mutateAsync(state.values);

                  case 2:
                    data = _context2.sent;

                    if (data === true) {
                      setState(_objectSpread(_objectSpread({}, state), {}, {
                        resendDisabled: true
                      }));
                      setTimeout(function () {
                        setState(function (state) {
                          return state.resendDisabled ? _objectSpread(_objectSpread({}, state), {}, {
                            resendDisabled: false
                          }) : _objectSpread({}, state);
                        });
                      }, 15000);
                    }

                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          })),
          resendDisabled: state.resendDisabled
        }) : null]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: sitemap/* SITEMAP.LOGIN */.a.LOGIN,
        passHref: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWithIcon/* default */.Z, {
          size: "lg",
          variant: "subtle",
          iconName: "leftArrow",
          children: "BACK TO LOG IN"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrackerWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProgressTracker/* default */.Z, {
          activeStep: state.step,
          steps: 3
        })
      })]
    })
  });
};

/* harmony default export */ var ForgotPassword = (ForgotPasswordPage);
;// CONCATENATED MODULE: ./src/pages/auth/forgot-password.tsx





var __N_SSP = true;
function forgot_password_ForgotPassword() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Dealer Portal - Forgot Password"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ForgotPassword, {})]
  });
}

/***/ }),

/***/ 53349:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/forgot-password",
      function () {
        return __webpack_require__(43892);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,7977,4231,9436,1336,6866,9774,2888,179], function() { return __webpack_exec__(53349); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);